<div class="join-us-container mat-elevation-z0" id="joinUs">
  <div fxLayout="row wrap">
    <div fxFlex.gt-sm="50" fxFlex.lt-sm="100" class="row-container">
      <div class="content" style="text-align: center;">
        <h1 class="Join-title">Offer your customers a<br /><span>flexible interest free<br /></span>payment option.</h1>
        <br>
        <p class="info-paragraph">In today's fast paced and ever changing retail environment, give your customer's a
          risk free, interest free payment option while increasing your sales.</p>
        <br>
        <button mat-stroked-button [routerLink]="['/merchant/signup']" (click)="scrollTo('top')">JOIN US</button>
      </div>
    </div>
    <div fxFlex.gt-sm="50" fxFlex.lt-sm="0" class="join"></div>
  </div>
</div>
<div fxLayout="row wrap" fxLayoutAlign="stretch">
  <div fxFlex.gt-sm="50" fxFlex.lt-sm="100" class="half-1" id="howItWorks">
    <div class="how-it-works-join" >
      <div class="content">
        <h1>Interest in joining but still have<br/>some questions?</h1>
        <br>
        <p class="info-paragraph">Read through our Frequently Asked Questions.</p>
        <a mat-stroked-button [routerLink]="['/merchant-faq']" (click)="scrollTo('top')" class="btn-action">READ MORE</a>
      </div>
    </div>
  </div>
  <div fxFlex.gt-sm="50" fxFlex.lt-sm="100" class="half-2">
    <div class="how-it-works-partner">
      <div class="content">
        <h1>Zero risk, boost in sales, increase in basket size, upfront payment, greater customer loyalty…</h1>
        <br>
        <p class="info-paragraph">There are many benefits to offering your customers an alternative way to pay. </p>
        <a mat-stroked-button [routerLink]="['/merchant/signup']" (click)="scrollTo('top')" class="btn-action">JOIN US</a>
      </div>
    </div>
  </div>
  <div fxFlex="100">
    <div class="how-it-works-contact">
      <div class="content">
        <h1>Contact us, we would love <br>to have you as a spend partner.</h1>
        <a mat-stroked-button class="btn-action" (click)="contact();">CONTACT US</a>
      </div>
    </div>
  </div>
</div>
